module.exports = __webpack_public_path__ + "img/square-right.f1c505df.svg";